import config from "../services/config";

/** @typedef {"local" | "dev" | "prod"} AddInOrigin */

const PROD_HOSTS = new Set(["outlook.unicli.ai", "word.unicli.ai"]);
const DEV_HOSTS = new Set(["outlook-dev.unicli.ai", "word-dev.unicli.ai"]);

/**
 * Resolves which add-in deployment is calling the backend.
 * Used by auth/sso so Xano can select the correct Azure OBO client/scopes.
 * @returns {AddInOrigin}
 */
export const getAddInOrigin = () => {
  try {
    const hostname = window.location.hostname.toLowerCase();
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "local";
    }
    if (PROD_HOSTS.has(hostname)) {
      return "prod";
    }
    if (DEV_HOSTS.has(hostname)) {
      return "dev";
    }
  } catch {
    // fall through to config-based default
  }

  return config.DataSource === "live" ? "prod" : "dev";
};
